import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from '@reach/router';
import { useSelector, useDispatch } from 'react-redux';
import { User } from 'state/user/UserTypes';
import { RFC } from 'state/StateTypes';
import { AppState } from 'state/store';
import Loading from 'components/Loading';
import styled from 'styled-components';
import Button from 'components/Button';
import Subscription from 'components/Subscription';
import isAuthenticated from 'hooks/isAuthenticated';
import Container from 'components/Container';
import FormContainer from 'components/FormContainer';
import { InfoList, Info } from 'components/InfoList';
import Label from 'components/Label';
import FormHeader from 'components/FormHeader';
import { getProfile } from 'state/user/UserActions';
import { selectCurrentUser } from 'state/user/UserSelectors';
import ErrorMessage from 'components/ErrorMessage';
import { determineUserTier, presentErrorBasedOnCode } from 'utils';
import { Error, ErrorCodes } from 'types';

const AccountInfo: RFC<RouteComponentProps> = () => {
   const authenticated: boolean = isAuthenticated();
   const user: User | null = useSelector((state: AppState) => selectCurrentUser(state));
   const dispatch = useDispatch();
   const [error, setError] = useState<Error | null>(null);
   //setting loading as true by default removes the jarring flash of loading spinner
   const [loading, setLoading] = useState<boolean>(true);

   useEffect(() => {
      (async () => {
         if (authenticated) {
            try {
               await dispatch(getProfile());
            } catch (error) {
               setError(error);
            }
            setLoading(false);
         }
      })();
   }, []);

   return loading ? (
      <Loading />
   ) : (
      <Container margin="0 auto">
         <FormContainer>
            <Header>ACCOUNT INFO</Header>
            <InfoList>
               <Info>
                  <Label>Email</Label>
                  <span>{user ? user.email : ''}</span>
               </Info>
               <Info>
                  <Label>Tier</Label>
                  <span>{user ? determineUserTier(user) : ''}</span>
               </Info>
               <Info>
                  <Label>First Name</Label>
                  <span>{user ? user.firstName : ''}</span>
               </Info>
               <Info>
                  <Label>Last Name</Label>
                  <span>{user ? user.lastName : ''}</span>
               </Info>
               <Info>
                  <Label>Phone</Label>
                  <span>{user ? user.phone : ''}</span>
               </Info>
            </InfoList>
            <Button to="/profile/edit">EDIT ACCOUNT</Button>
         </FormContainer>
         {error && <ErrorMessage>{presentErrorBasedOnCode(error.code as ErrorCodes)}</ErrorMessage>}
         {user && !!user.subscription.length && <Header>Subscriptions</Header>}
         {user && !!user.subscription.length && user.subscription.map((subscription, i) => <Subscription subscription={subscription} key={i} />)}
      </Container>
   );
};

export default AccountInfo;

const Header = styled(FormHeader)`
   margin: 0 auto 0.5em auto;
   text-align: center;
`;
